import React, { useCallback, useMemo } from 'react';
import MappingTableRow from '../../TableRow';
import { MappingTypeSimpleBase } from '../Simple';
import { Checkbox, Stack } from '@chaser/components';
import { useReadOnly } from '../../readOnlyContext';

export const getConsumedColumns = value => {
  return {
    [value?.columnId]: true,
  };
};

const MappingTypeLastName = ({ field, value, availableColumns, onChange }) => {
  const handleOnColumnChange = useCallback(
    patch => {
      onChange(patch?.columnId ? { columnId: patch?.columnId, splitFromFirstName: false } : null);
    },
    [onChange],
  );

  const handleOnNameSplitChange = useCallback(
    ({ target: { checked } }) => {
      onChange(!checked ? null : { splitFromFirstName: true });
    },
    [onChange],
  );

  // it needs to be always defined
  const splitFromFirstName = useMemo(() => !!value?.splitFromFirstName, [value]);

  const readOnly = useReadOnly();

  return (
    <MappingTableRow field={field}>
      <Stack gap="small">
        <Checkbox
          checked={splitFromFirstName}
          onChange={handleOnNameSplitChange}
          disabled={readOnly}
        >
          Share with First Name
        </Checkbox>

        <MappingTypeSimpleBase
          value={value}
          availableColumns={availableColumns}
          onChange={handleOnColumnChange}
          required={field.required}
          disabled={splitFromFirstName}
        />
      </Stack>
    </MappingTableRow>
  );
};

export const Component = MappingTypeLastName;
